import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { landlordFindPropertySearcherQuery } from '../+state/gql-queries';
import { ProspectsSearchResult } from '../models/search-result.model';

@Injectable()
export class SearchFacade {
  private apollo = inject(Apollo);

  public searchProspects(searchTerm: string) {
    return this.apollo.query<ProspectsSearchResult>({
      query: landlordFindPropertySearcherQuery,
      variables: {
        searchTerm
      }
    });
  }
}
